<div
  #phoneWrapper
  class="phone-input-wrapper"
  (focusout)="markAsTouched()"
>
  <app-input-reusable
    type="tel"
    [size]="size"
    [label]="label"
    [labelClass]="labelClass"
    [required]="required"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [control]="phoneControl"
  >
    <span suffix-icon class="phone-input-suffix-icon inline-flex items-center justify-center text-slate600" aria-hidden="true">
      <svg [attr.width]="suffixIconSize" [attr.height]="suffixIconSize" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5003 1.25C14.3413 1.25 15.8337 2.74238 15.8337 4.58333V15.4167C15.8337 17.2576 14.3413 18.75 12.5003 18.75H7.50033C5.65938 18.75 4.16699 17.2576 4.16699 15.4167V4.58333C4.16699 2.74238 5.65938 1.25 7.50033 1.25H12.5003ZM5.83366 4.58333C5.83366 3.66286 6.57985 2.91667 7.50033 2.91667H7.98812C8.15972 3.40216 8.62273 3.75 9.16699 3.75H10.8337C11.3779 3.75 11.8409 3.40216 12.0125 2.91667H12.5003C13.4208 2.91667 14.167 3.66286 14.167 4.58333V15.4167C14.167 16.3371 13.4208 17.0833 12.5003 17.0833H7.50033C6.57985 17.0833 5.83366 16.3371 5.83366 15.4167V4.58333Z" fill="currentColor"></path>
      </svg>
    </span>
  </app-input-reusable>
</div>
